import { useDynamicContext } from '@dynamic-labs/sdk-react-core';

import { Metadata } from '@repo/types-client';
import { Icon, tw } from '@repo/ui';

import { useClaim } from '../../../../../hooks/use-claim';
import { ClaimButton } from '../../../../button';

interface ClaimStatusProps {
  status: 'preparing' | 'error' | 'ok' | 'rejected';
  title: string;
  subtitle?: string;
  hideClaimButton?: boolean;
  hideIcon?: boolean;
}

export const ClaimStatus: React.FC<ClaimStatusProps> = ({
  title,
  subtitle,
  hideClaimButton = false,
  hideIcon = false,
  status,
}) => {
  const { user } = useDynamicContext();
  const { isDecompressing, handleDecompress } = useClaim();

  return (
    <div
      className={tw(
        'flex w-full flex-col justify-center gap-5',
        'md:flex-row',
        status === 'preparing' ? 'md:justify-center' : 'md:justify-between',
      )}
    >
      <div className='flex flex-row items-center gap-4'>
        {!hideIcon ? (
          <div
            className={tw(
              'flex h-8 w-8 min-w-8 items-center justify-center rounded-full',
              status === 'ok' ? 'bg-[#05FEA8]' : 'bg-[#FC7CC5]',
            )}
          >
            <Icon
              folder='core'
              name='checkmark-fill'
              height={20}
              width={20}
            />
          </div>
        ) : null}
        <div className='flex flex-col items-start'>
          <p
            className={tw(
              'text-left text-xl font-semibold text-white',
              status === 'rejected' ? 'md:text-[26px]' : 'md:text-[32px]',
            )}
          >
            {title}
          </p>
          {subtitle ? (
            <p className='text-sm font-light text-white/50 md:text-base'>
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {!hideClaimButton ? (
        <div className='w-full md:w-[200px]'>
          <ClaimButton
            text='CLAIM NOW'
            onClick={() =>
              handleDecompress(
                (user?.metadata as Metadata)?.solanaClaimAddress as string,
              )
            }
            className='p-[1.5rem]'
            isLoading={isDecompressing}
            disabled={isDecompressing}
            hasEnoughSol={true}
            hasSolWallet={true}
          />
        </div>
      ) : null}
    </div>
  );
};
